export default {
  desktop: {
    ThemeImporter: () => import(/* webpackChunkName: "maxbet-themeWrap" */'./ThemeImporter'),
  },
  mobile: {
    ThemeImporter: () => import(/* webpackChunkName: "maxbet-themeWrap" */'./ThemeImporter'),
  },
};
